import { render, staticRenderFns } from "./SectorIndicesTab.vue?vue&type=template&id=78e88fc4&"
import script from "./SectorIndicesTab.vue?vue&type=script&lang=js&"
export * from "./SectorIndicesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports